// @adr O-ADR-044 AI-824: fonts self-hosted via local @font-face in global.css, pointing at
// /fonts/*.woff2 (copied from @fontsource into static/fonts/). We do NOT import the
// @fontsource CSS packages — v5.2.8 ships latin-400/500 .woff2 but is MISSING their .woff,
// and its CSS references both, which breaks the webpack build. Self-hosting woff2-only
// (latin, font-display:swap) avoids that, drops the third-party request, and is preloadable.
import "./src/styles/global.css";

// @adr O-ADR-044 AI-831: suppress the benign Gatsby RouteAnnouncer hydration noise.
//
// Gatsby v5.16's internal `RouteAnnouncer` (the visually-hidden `#gatsby-announcer`
// aria-live region) triggers a recoverable React-18 hydration mismatch (#418 → #423) on
// initial load. Verified via the component stack (`--profile` build): the ONLY divergent
// node is the framework announcer `<div>` — every page's own content hydrates cleanly, and
// the announcer SSR markup is byte-identical across all routes. It's intermittent and
// framework-level (not our code), but React logs recoverable errors to `console.error` by
// default, which fails Lighthouse's `errors-in-console` audit (Best Practices < 100).
//
// React's `onRecoverableError` lets us own that logging. We swallow ONLY hydration-recovery
// codes (#418/#419/#423/#425) and still surface anything genuinely unexpected — so a real
// future hydration bug in our own code is NOT masked.
// Refs: react.dev/errors/418, /423 · react.dev hydrateRoot (onRecoverableError) ·
//       gatsbyjs/gatsby discussion #36232.
export const replaceHydrateFunction = () => (element, container) => {
  // eslint-disable-next-line global-require
  const { hydrateRoot } = require("react-dom/client");
  return hydrateRoot(container, element, {
    onRecoverableError: (error) => {
      const msg = (error && error.message) || "";
      const isHydrationRecovery = /(\b41[89]\b|\b42[35]\b|hydrat)/i.test(msg);
      if (!isHydrationRecovery) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  });
};
